import {
  BooleanInput,
  Edit,
  SelectInput,
  SimpleForm,
  TextInput,
} from 'react-admin';
import { StaffMarketsCard } from './StaffMarkets';
import { formatStaffPhone, toE164, validateStaffPhone } from './staffPhone';

const roleChoices = [
  { id: 'admin', name: 'Admin' },
  { id: 'director', name: 'Director' },
  { id: 'coordinator', name: 'Coordinator' },
  { id: 'staff', name: 'Staff' },
  { id: 'operations', name: 'Operations' },
  { id: 'public_user', name: 'Public User' },
];

const languageChoices = [
  { id: 'en', name: 'English' },
  { id: 'fr', name: 'French' },
];

export const ProfilesEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="name" />
      <TextInput source="email" disabled />
      <SelectInput source="role" choices={roleChoices} />
      <BooleanInput source="active" />
      <TextInput source="initials" />
      <SelectInput source="language_preference" choices={languageChoices} />
      <TextInput source="slack_user_id" label="Slack User ID" />
      <TextInput source="aircall_user_id" label="Aircall User ID" />
      <TextInput
        source="phone"
        label="Mobile phone"
        helperText="Texted and called for after-hours callback requests when on the on-call rota."
        validate={validateStaffPhone}
        format={(v: string | null) => formatStaffPhone(v)}
        parse={(v: string) => toE164(v)}
      />
    </SimpleForm>
    <StaffMarketsCard />
  </Edit>
);
